import cn from "classnames"

import { Img, Text } from "ui-kit/components-branded/index"
import { Analytics } from "utils/analytics"
import { APP_PAGE_URL } from "utils/env-management"

export function CertificateBlock({ className }: { className?: string }) {
    function handleClickButton() {
        Analytics.certificate_block_button_clicked()
    }

    return (
        <div className={cn("certificate__block", className)}>
            <Text isAccent className="certificate-block__head mgb-4">
                <span className="mgr-3">
                    Позаботьтесь о&nbsp;своих близких&nbsp;&mdash; подарите сертификат Alter
                </span>
                <span className="certificate-block__image">
                    <Img src="gift.png" />
                </span>
            </Text>
            <Text className="certificate-block__description is-block mgb-2">
                Дарите сертификат только если ваш близкий открыто выразил желание пойти
                на&nbsp;терапию.
            </Text>
            <a
                className="button-secondary is-responsive w-100"
                href={`${APP_PAGE_URL}/gift`}
                onClick={handleClickButton}
            >
                <Text isAccent>Выбрать сертификат</Text>
            </a>
        </div>
    )
}
